import { NgModule, APP_INITIALIZER, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, createComponent } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { StoreModule } from '@ngrx/store';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { LoggedInUserService, AuthGuardService } from './shared/services/auth/auth.guard.service';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { IbdSdkService } from './shared/services/common/ibd-sdk.service';
import { AuthenticationService } from './shared/services/auth/authentication.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressLoaderService } from './shared/services/loader/progressLoader.service';
import { HttpService } from './shared/services/common/http.service';
import { NotificationService } from './shared/services/notification/notification.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ShsSdkService } from './shared/services/common/shs-sdk.service';
import { IconService } from './shared/utils/icons-register';

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true,
    }),
    CommonModule,
    NgbModule,
    ToastModule,
    NgxSpinnerModule
  ],
  providers: [
    LoggedInUserService,
    AuthGuardService,
    ProgressLoaderService,
    AuthenticationService,
    NotificationService,
    IbdSdkService,
    ShsSdkService,
    HttpService,
    MessageService,
    IconService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
